module.exports = "<div v-if=loading transition=fade class=\"Lightbox Lightbox--open animated\"><spinner :loading.sync=loading></spinner></div><div :skin=skins.app><fg-header :content=workflow.header></fg-header><fg-body :fragments=workflow.body :layout=workflow.layout :uid=uid></fg-body><fg-footer :content=workflow.footer></fg-footer></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/workflows/workflow.vue
// module id = 482
// module chunks = 0